import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form, Input, Button, Select } from "antd";
import { RequiredField } from "../required-field/RequiredField";
import { updateClientes } from "../../actions/ClientAction";
import {
  getClients,
  getTypeClients,
  getTypeBusinessClients
} from "../../actions/ClientsAction";
import { sendNotification, isEmail } from "../../utils";
import ActivationModules from "../modules-activation/ActivationModules";

const { Option } = Select;

const services = [
  {
    value: "Servicios de Publicidad"
  },
  {
    value: "Producción Audiovisual"
  },
  {
    value: "Imprenta"
  },
  {
    value: "Animación Digital"
  },
  {
    value: "Servicios/Asesorías"
  },
  {
    value: "Diseño Gráfico"
  },
  {
    value: "Community Manager"
  },
  {
    value: "Web"
  },
  {
    value: "Arquitectura"
  },
  {
    value: "Estrategias de Mercadeo"
  },
  {
    value: "Ilustraciones"
  },
  {
    value: "Estudiante"
  },
  {
    value: "Otro"
  }
];
export class EditClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dni: "",
      companyName: "",
      agent: "",
      phone: "",
      email: "",
      clientType: "",
      businessType: "",
      modules: [],
      dartCustomField: "",
      contractedUsers: "",
      contractedSpace: "",
      options: [],
      optionBusiness: [],
      listTypeBusinessClient: services,
      editable: false
    };
  }

  componentDidMount() {
    const { editData, listTypeClient } = this.props;
    const { listTypeBusinessClient } = this.state;

    this.setState({
      dni: editData.dni.trim(),
      companyName: editData.companyName.trim(),
      agent: editData.agent,
      phone: editData.phone,
      email: editData.email,
      editable: editData.editable,
      clientType: editData.clientType,
      businessType: editData.businessType,
      modules: editData.modules,
      dartCustomField: editData.dartCustomField
        ? editData.dartCustomField.trim()
        : editData.dartCustomField,
      contractedUsers: editData.contractedUsers,
      contractedSpace: editData.contractedSpace,
      media: editData.media,
      statusAsset: editData.statusAsset,
      options: listTypeClient.map((r, k) => (
        <Option key={k} value={r._id} uid={r._id}>
          {r.name}
        </Option>
      )),
      optionBusiness: listTypeBusinessClient.map((r, k) => (
        <Option key={k} value={r.value} uid={r.value}>
          {r.value}
        </Option>
      ))
    });
  }

  componentDidUpdate(prevProps) {
    const { clientUpdate, intl } = this.props;

    if (clientUpdate && clientUpdate !== prevProps.clientUpdate) {
      sendNotification(
        "success",
        intl,
        intl.formatMessage({ id: "client_edit_successfully" })
      );
      this.props.handleHideEditClient();
    }
    if (prevProps.listTypeClient !== this.props.listTypeClient) {
      const listTypeClient = this.props.listTypeClient;
      if (listTypeClient.length > 0) {
        this.setState({
          options: listTypeClient.map((r, k) => (
            <Option key={k} value={r._id} uid={r._id}>
              {r.name}
            </Option>
          ))
        });
      }
    }
    if (
      prevProps.listTypeBusinessClient !== this.props.listTypeBusinessClient
    ) {
      const listTypeBusinessClient = this.props.listTypeBusinessClient;
      if (listTypeBusinessClient.length > 0) {
        this.setState({
          optionBusiness: listTypeBusinessClient.map((r, k) => (
            <Option key={k} value={r.name} uid={r._id}>
              {r.name}
            </Option>
          ))
        });
      }
    }
  }

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSendModules = modules => {
    this.setState({ modules: modules });
  };

  handleOnClientTypeChange = value => {
    this.setState({
      clientType: value
    });
  };

  handleOnBusinessTypeChange = value => {
    this.setState({
      businessType: value
    });
  };

  handleUpdateClientes = () => {
    const {
      companyName,
      email,
      dni,
      agent,
      phone,
      modules,
      dartCustomField,
      media,
      statusAsset,
      contractedUsers,
      contractedSpace,
      clientType,
      businessType
    } = this.state;
    const { activePage, intl, editData } = this.props;

    if (
      !companyName ||
      !dni ||
      !dartCustomField ||
      !contractedUsers ||
      !contractedSpace ||
      !clientType ||
      !businessType
    ) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "enter_required_fields" })
      );
    } else if (!isEmail(email)) {
      sendNotification(
        "error",
        intl,
        intl.formatMessage({ id: "not_valid_email" })
      );
    } else {
      this.props.updateClientes(
        editData._id,
        dni,
        companyName,
        agent,
        phone,
        email,
        modules,
        dartCustomField,
        media,
        statusAsset,
        contractedUsers,
        contractedSpace,
        clientType,
        businessType
      );
      setTimeout(() => {
        this.props.getClients(activePage);
        this.props.getTypeClients();
        this.props.getTypeBusinessClients();
      }, 1000);
    }
  };

  render() {
    const { intl, handleHideEditClient } = this.props;
    const {
      dni,
      companyName,
      agent,
      phone,
      email,
      modules,
      dartCustomField,
      contractedUsers,
      contractedSpace,
      clientType,
      businessType,
      options,
      optionBusiness,
      editable
    } = this.state;
    return (
      <Form>
        <Form.Item style={{ marginBottom: "3px" }}>
          <RequiredField name={intl.formatMessage({ id: "rut_company" })} />
          <Input name="dni" value={dni} onChange={this.handleInputOnChange} />
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <RequiredField name={intl.formatMessage({ id: "business_name" })} />
          <Input
            name="companyName"
            value={companyName}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "13px" }}>
          <span>{intl.formatMessage({ id: "contact" })}</span>
          <Input
            name="agent"
            value={agent}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <span>{intl.formatMessage({ id: "phone" })}</span>
          <Input
            name="phone"
            value={phone}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <span>{intl.formatMessage({ id: "email" })}</span>
          <Input
            name="email"
            value={email}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "type_clients" })} />
          <Select
            defaultValue={clientType}
            onChange={this.handleOnClientTypeChange}
            value={clientType}
          >
            {options}
          </Select>
        </Form.Item>
        <Form.Item>
          <RequiredField name={intl.formatMessage({ id: "type_business" })} />
          <Select
            defaultValue={intl.formatMessage({ id: "all" })}
            onChange={this.handleOnBusinessTypeChange}
            value={businessType}
          >
            {optionBusiness}
          </Select>
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <RequiredField
            name={intl.formatMessage({ id: "dart_custom_field" })}
          />
          <Input
            name="dartCustomField"
            value={dartCustomField}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <RequiredField
            name={intl.formatMessage({ id: "contracted_users" })}
          />
          <Input
            name="contractedUsers"
            value={contractedUsers}
            disabled={!editable}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: "3px" }}>
          <RequiredField
            name={intl.formatMessage({ id: "contracted_space" })}
          />
          <Input
            name="contractedSpace"
            value={contractedSpace}
            disabled={!editable}
            onChange={this.handleInputOnChange}
          />
        </Form.Item>
        <Form.Item>
          <span>{intl.formatMessage({ id: "modules" })}</span>
          <ActivationModules
            isIndividualComponent={false}
            handleSendModules={this.handleSendModules}
            modules={modules}
          />
        </Form.Item>
        <Form.Item style={{ marginTop: "10px", marginBottom: "0px" }}>
          <Button onClick={() => this.handleUpdateClientes({})}>
            {intl.formatMessage({ id: "edit_asset" })}
          </Button>
          <Button style={{ marginLeft: "8px" }} onClick={handleHideEditClient}>
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Form.Item>
        <Form.Item>
          <span style={{ color: "red" }}>(*) </span>
          <span>{intl.formatMessage({ id: "required_fields" })}</span>
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  data: state.clients.data,
  clientUpdate: state.client.clientUpdate,
  listTypeClient: state.clients.listTypeClient,
  listTypeBusinessClient: state.clients.listTypeBusinessClient
});

const mapDispatchToProps = {
  updateClientes,
  getClients,
  getTypeClients,
  getTypeBusinessClients
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(EditClient))
);
